import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type Conversation = components["schemas"]["Conversation"];

/** PATCH /v1/chat/conversations/{id} — rename. */
export async function renameConversation(id: string, title: string): Promise<Conversation> {
  return unwrap(
    await api.PATCH("/v1/chat/conversations/{id}", {
      params: { path: { id } },
      body: { title },
    }),
  );
}

/** DELETE /v1/chat/conversations/{id}. */
export async function deleteConversation(id: string): Promise<void> {
  unwrap(await api.DELETE("/v1/chat/conversations/{id}", { params: { path: { id } } }));
}

/** POST /v1/chat/conversations/{id}/favorite — toggle favorite status. */
export async function toggleFavorite(id: string): Promise<Conversation> {
  return unwrap(
    await api.POST("/v1/chat/conversations/{id}/favorite", { params: { path: { id } } }),
  );
}
